<div class="nova-insight-widget" *ngIf="showWidget">
  <button
    type="button"
    class="nova-insight-widget__dismiss"
    aria-label="Dismiss insight"
    (click)="onDismiss()"
  >
    <svg-icon src="assets/icons/icon-close.svg"></svg-icon>
  </button>

  <div class="nova-insight-widget__inner">
    <div
      class="nova-insight-widget__top"
      role="button"
      tabindex="0"
      aria-label="Open Nova's insight"
      (click)="onOpen()"
      (keydown.enter)="onOpen()"
      (keydown.space)="onOpen()"
    >
      <img
        class="nova-insight-widget__doodat"
        src="assets/nova/nova-mascot.png"
        alt=""
        aria-hidden="true"
      />
      <div class="nova-insight-widget__text">
        <p class="nova-insight-widget__title">{{ card.snackbarTitle }}</p>
        <p class="nova-insight-widget__sentence">{{ card.snackbarSentence }}</p>
      </div>
    </div>
    <app-pill-button
      class="nova-insight-widget__action"
      title="Read Nova's insight"
      size="micro"
      backgroundColor="var(--color-sagebrush)"
      textColor="var(--color-evergreen)"
      forwardIconColor="var(--color-evergreen)"
      (clicked)="onOpen()"
    ></app-pill-button>
  </div>

  <!-- FLIP-393 N05: attached to the first eligible Insight. No control of its own - the snackbar's
       open and dismiss above are the only ones. No Figma design exists for this yet. -->
  <div *ngIf="n05Attached" class="nova-insight-widget__explain" role="note">
    <p class="nova-insight-widget__explain-heading">{{ n05Copy.heading }}</p>
    <p class="nova-insight-widget__explain-body" *ngFor="let paragraph of n05Copy.paragraphs">
      {{ paragraph }}
    </p>
  </div>
</div>
